(function () {
    'use strict';

    var $ = avm.require('cash'),
        url = document.location.href,
        acceptedHost = ['id-stage.avast.com', 'id.avast.com'],
        unserializedUrl = avm.require('avast.url.unserialize'),
        $button = $('.urlTarget .btn');

        if (unserializedUrl(url)['link'] != undefined) {
            var link = unserializedUrl(url)['link'],
                domain = new URL(link);

            if (acceptedHost.indexOf(domain.host) > -1) {
                $button.attr('href', unserializedUrl(url)['link']);
            }
        }

})()
